module.exports = __webpack_public_path__ + "static/footerlogob-bdc89b1e325cb3d6a098775fe81cae6d.png";